import axios from '_lib/encrypt/axios'
import { getOSType, webpFormat, getRequestUrl, getUrlParam } from '_lib/utils'

const __DEFAULT_PARAMS__ = {
	os_type: 'web',
  app: 'heybox',
  client_type: 'mobile',
	version: '999.0.3',
	x_client_type: 'web',
	x_os_type: getOSType(),
	x_app: getUrlParam('x_app') || 'heybox',
	heybox_id: getUrlParam('heybox_id') || '-1'
}

let axios_id = 0
window.SUPPORT_WEBP = undefined
export function axiosGetHandler (url, args = {}, apps = {}) {
	let params = Object.assign({}, __DEFAULT_PARAMS__, apps, args)
	
  if (window.SUPPORT_WEBP == undefined) {
    return Promise.all([httpRequest('GET', url, params), webpFormat()]).then(res_list => res_list[0])
  } else {
    return httpRequest('GET', url, params)
  }
}

export function axiosPostHandler (url, args = {}, formdata, apps = {}) {
	let params = Object.assign({}, __DEFAULT_PARAMS__, apps, args)
	
  if (window.SUPPORT_WEBP == undefined) {
    return Promise.all([httpRequest('POST', url, params, formdata), webpFormat()]).then(res_list => res_list[0])
  } else {
    return httpRequest('POST', url, params, formdata)
  }
}

let resolves = {}
function httpRequest (method, url, args, formdata) {
	if (method === 'POST') {
		return axios.post(getRequestUrl(url), formdata, {
			headers: {
				"Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
			},
			timeout: 10000,
			responseType: "json",
			params: args
		})
	} else {
		return axios.get(getRequestUrl(url), {
			headers: {
				"Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
			},
			timeout: 10000,
			responseType: "json",
			params: args
		})
	}
}
